import './styles.scss'

import React from 'react'
import { useValues } from 'kea'

import howLogic from './logic'

export default function How () {
  const { howContents } = useValues(howLogic)

  return (
    <div className='how-section-wrapper'>
      {howContents &&
        howContents.map(([key, { title, description, icon: iconUrl }]) => {
          const alt = iconUrl && iconUrl.split('.')[0].split('/')[4]
          const src = iconUrl

          return (
            <div className='how-card' key={key}>
              {src && alt && <img src={src} alt={alt} />}
              <p className='title'>{title}</p>
              <p className='description'>{description}</p>
            </div>
          )
        })}
    </div>
  )
}
